

const initialState = {
    timeSlots: [],
    locationValue1: [],
    attendanceItems: [],
    attendanceDetails: [],
    holidays: [],
    loading: false, 
    data: null, 
    error: null,  
    sundayData: [],
  };
  
  export const timeSlotReducer = (state = initialState, action) => { 
    switch (action.type) {
        case "FETCH_TIMES_REQUEST":
          return { ...state, loading: true };
        case "FETCH_TIMES_SUCCESS":
          return { ...state, timeSlots:action.payload, loading: false };
        case "FETCH_TIMES_FAILURE":
          return { ...state, error:action.payload,loading: false };
        default:
          return state; // Always return state
      }      
  };

  export const otjobAttendanceReducer = (state = initialState, action) => {
    switch (action.type) {
      case "FETCH_OT_JOB_ATTENDANCE_REQUEST":
        return { ...state, loading: true };
      case "FETCH_OT_JOB_ATTENDANCE_SUCCESS":
        //console.log("doo",action.payload);
        return { ...state, attendanceItems: action.payload, loading: false };
      case "FETCH_OT_JOB_ATTENDANCE_FAILURE":
        return { ...state, loading: false };
      default:
        return state; // Always return state
    }
  };
  

  export const otdetailsReducer = (state = initialState, action) => {
    switch (action.type) {
      case "FETCH_OT_DETAILS_ATTENDANCE_REQUEST":
        return { ...state, loading: true };
      case "FETCH_OT_DETAILS_ATTENDANCE_SUCCESS":
        //console.log("doo",action.payload);
        return { ...state, attendanceDetails: action.payload, loading: false };
      case "FETCH_OT_DETAILS_ATTENDANCE_FAILURE":
        return { ...state, loading: false };
      default:
        return state; // Always return state
    }
  };

  export const  otAssignReducer = (state = initialState, action) => {
    switch (action.type) {
      case "ASSIGN_OT_REQUEST":
        return {
          ...state, loading: true, error: null,
        };
      case "ASSIGN_OT_SUCCESS":
        return {
          ...state, loading: false, data: action.payload, // Success data
        };
      case "ASSIGN_OT_FAILURE":
        return {
          ...state, loading: false, error: action.error,
        };
      default:
        return state;
    }
  };

  export const sundayDataReducer = (state = initialState, action) => {
    switch (action.type) {
      case "FETCH_SUNDAY_DATA_REQUEST":
        return { ...state, loading: true };
      case "FETCH_SUNDAY_DATA_SUCCESS":
        return { ...state, sundayData: action.payload, loading: false };
      case "FETCH_SUNDAY_DATA_FAILURE":
        return { ...state, error: action.payload, loading: false };
      default:
        return state;
    }
  };

  export const holidaysReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_HOLIDAYS_REQUEST":
      return { ...state, loading: true, error: null };
    case "FETCH_HOLIDAYS_SUCCESS":
      return { ...state, loading: false, holidays: action.payload };
    case "FETCH_HOLIDAYS_FAILURE":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
  
  
  